import { render, staticRenderFns } from "./ItemQuota.vue?vue&type=template&id=4adbf2a8&"
import script from "./ItemQuota.vue?vue&type=script&lang=js&"
export * from "./ItemQuota.vue?vue&type=script&lang=js&"
import style0 from "./ItemQuota.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports